import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export const parseAdyenTranslations = (translations?: string) => {
    try {
        return translations?.trim() ? JSON.parse(translations) : "";
    } catch (error) {
        Logger.error(ServiceType.ADYEN, "Error during parsing Adyen translations", {
            error,
            translations,
            tag: LogTag.CHECKOUT,
        });
        return {};
    }
};
